import React from "react";
import { useNavigate } from "react-router-dom";
import ShortLayout from "../../components/layout/ShortLayout";

const LinkExpired: React.FC = () => {
  const navigate = useNavigate();

  return (
    <ShortLayout headerStyle={1} footerStyle={2}>
      <div style={{ padding: 40, textAlign: "center" }}>
        <h1>Link Expired</h1>
        <p>The shared link is invalid or has expired. It may have been deleted by the owner.</p>
        <div style={{ marginTop: 24 }}>
          <button className="ant-btn ant-btn-primary" onClick={() => navigate('/')}>Go to Homepage</button>
        </div>
      </div>
    </ShortLayout>
  );
};

export default LinkExpired;
